import { userActionTypeEnum } from '@thoughtspot/metrics';
import { CategoryType } from '../../../types';
export const getNumberFormatMixPanelConfig = (updatedValue, previousValue, source) => {
    if (updatedValue.category !== previousValue.category) {
        return {
            eventName: userActionTypeEnum.NUMBER_FORMAT_CATEGORY,
            properties: {
                categoryType: updatedValue.category,
                ...(source && { source }),
            },
        };
    }
    const CategoryTypeToFormatConfig = {
        [CategoryType.Number]: 'numberFormatConfig',
        [CategoryType.Percentage]: 'percentageFormatConfig',
        [CategoryType.Currency]: 'currencyFormatConfig',
        [CategoryType.Custom]: 'customFormatConfig',
    };
    const perviousFormatConfig = previousValue[CategoryTypeToFormatConfig[previousValue.category]];
    const updatedFormatConfig = updatedValue[CategoryTypeToFormatConfig[updatedValue.category]];
    if (perviousFormatConfig.unit !== updatedFormatConfig.unit) {
        return {
            eventName: userActionTypeEnum.NUMBER_FORMAT_UNIT,
            properties: {
                unitType: updatedFormatConfig.unit,
                ...(source && { source }),
            },
        };
    }
    if (perviousFormatConfig.negativeValueFormat !==
        updatedFormatConfig.negativeValueFormat) {
        return {
            eventName: userActionTypeEnum.NUMBER_FORMAT_NEGATIVE_VALUES,
            properties: {
                negativeValueFormatType: updatedFormatConfig.negativeValueFormat,
                ...(source && { source }),
            },
        };
    }
    return {
        eventName: userActionTypeEnum.NUMBER_FORMAT,
        ...(source && { source }),
    };
};
export const getMixpanelConfigForLineStyle = (updatedValue, previousValue, source, includeColorOption = true) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.dashStyle) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.dashStyle)) {
        return {
            eventName: userActionTypeEnum.CHANGE_LINE_TYPE,
            properties: {
                type: updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.dashStyle,
                source,
            },
        };
    }
    if (includeColorOption && (updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.color) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.color)) {
        return {
            eventName: userActionTypeEnum.CHANGE_LINE_COLOR,
            properties: {
                source,
            },
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_LINE_THICKNESS_SIZE,
        properties: {
            source,
        },
    };
};
export const getMixpanelConfigForFontStyle = (updatedValue, previousValue, source) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.color) !== undefined &&
        (previousValue === null || previousValue === void 0 ? void 0 : previousValue.color) !== undefined &&
        updatedValue.color !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.color)) {
        return {
            eventName: userActionTypeEnum.CHANGE_TEXT_COLOR,
            properties: {
                color: updatedValue.color,
                source,
            },
        };
    }
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.size) !== undefined &&
        (previousValue === null || previousValue === void 0 ? void 0 : previousValue.size) !== undefined &&
        updatedValue.size !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.size)) {
        return {
            eventName: userActionTypeEnum.CHANGE_TEXT_SIZE,
            properties: {
                size: updatedValue.size,
                source,
            },
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_TEXT_FORMAT,
        properties: {
            style: updatedValue.style,
            source,
        },
    };
};
export const getMixpanelConfigForIntervalStyle = (updatedValue, previousValue) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.length) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.length)) {
        return {
            eventName: userActionTypeEnum.CHANGE_INTERVAL_LENGTH,
        };
    }
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.thickness) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.thickness)) {
        return {
            eventName: userActionTypeEnum.CHANGE_INTERVAL_THICKNESS,
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_INTERVAL_COLOR,
    };
};
export const getMixpanelConfigForBackgroundStyle = (updatedValue, previousValue, source) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.backgroundColor) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.backgroundColor)) {
        return {
            eventName: userActionTypeEnum.CHANGE_BACKGROUND_COLOR,
            properties: {
                source,
            },
        };
    }
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.borderColor) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.borderColor)) {
        return {
            eventName: userActionTypeEnum.CHANGE_BACKGROUND_BORDER_COLOR,
            properties: {
                source,
            },
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_BACKGROUND_OPACITY,
        properties: {
            source,
        },
    };
};
export const getMixpanelConfigForBorderStyle = (updatedValue, previousValue) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.color) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.color)) {
        return {
            eventName: userActionTypeEnum.CHANGE_BORDER_COLOR,
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_BORDER_THICKNESS,
    };
};
export const getMixpanelConfigForMarkerStyle = (updatedValue, previousValue) => {
    if ((updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.type) !== (previousValue === null || previousValue === void 0 ? void 0 : previousValue.type)) {
        return {
            eventName: userActionTypeEnum.CHANGE_MARKER_TYPE,
            properties: {
                markerType: updatedValue === null || updatedValue === void 0 ? void 0 : updatedValue.type,
            },
        };
    }
    return {
        eventName: userActionTypeEnum.CHANGE_MARKER_SIZE,
    };
};
//# sourceMappingURL=mixpanel-utils.js.map